<div class="flex flex-col h-full">
  <!-- Page Header -->
  <app-page-header [wrap]="true">
    <app-my-check-tabs [active]="isCatalog ? 'catalog' : 'runs'"></app-my-check-tabs>
    <div class="flex flex-row flex-wrap items-center justify-end gap-4">
      <!-- Suchleiste: schrumpft ab hier flexibel statt fix, damit unterhalb von 1760px (siehe
           restliche Buttons dieser Zeile) noch Platz für die Icon-only-Aktionen bleibt. -->
      <div class="flex-1 min-w-[140px] max-w-[268px]">
        <bic-input (valueChange)="searchQuery = $event"
                   [iconStart]="faMagnifyingGlass"
                   [placeholder]="'Suche nach...'"
                   [value]="searchQuery">
        </bic-input>
      </div>
      @if (!isCatalog) {
        <app-bic-filter (filtersChange)="onFiltersChange($event)" [filtersConfig]="filterConfig"
                        labelClass="bic-btn-label--compact"></app-bic-filter>
      }
      <!-- Button-Label bleibt statisch; pro Kriterium ein Pfeil-Paar für beide Sortierrichtungen.
           Unterhalb 1760px (siehe Breakpoint-Messung) reicht der Platz nicht mehr für alle
           Textlabels dieser Zeile in einer Reihe – ab da nur noch Icon + Tooltip. -->
      <bic-button [bicDropdownTrigger]="sortDropdown" buttonType="white" tooltip="Sortieren" tooltipDirection="bottom">
        <fa-icon [icon]="faArrowDownWideShort" iconLeft></fa-icon>
        <span class="bic-btn-label--compact">Sortieren</span>
      </bic-button>
      <bic-dropdown #sortDropdown [dropdownPlacement]="'bottom-end'" class="contents">
        <div class="w-[200px] py-1">
          @for (opt of sortFieldOptions; track opt.field) {
            <div class="flex flex-row items-center justify-between gap-3 px-3 py-1 hover:bg-gray-50">
              <span class="text-sm text-gray-900">{{ opt.label }}</span>
              <div class="flex flex-row items-center gap-0.5">
                <button (click)="applySort(opt.field, 'asc')"
                        [class]="'p-0.5 hover:text-[#000] ' + (sortField === opt.field && sortDirection === 'asc' ? 'text-[#000]' : 'text-gray-300')"
                        [tooltip]="opt.ascLabel" tooltipDirection="top"
                        type="button">
                  <fa-icon [icon]="faArrowUpWideShort" class="text-sm"></fa-icon>
                </button>
                <button (click)="applySort(opt.field, 'desc')"
                        [class]="'p-0.5 hover:text-[#000] ' + (sortField === opt.field && sortDirection === 'desc' ? 'text-[#000]' : 'text-gray-300')"
                        [tooltip]="opt.descLabel" tooltipDirection="top"
                        type="button">
                  <fa-icon [icon]="faArrowDownWideShort" class="text-sm"></fa-icon>
                </button>
              </div>
            </div>
          }
        </div>
      </bic-dropdown>
      @if (!isCatalog) {
        <bic-button (onClick)="openFavoritesPopup()" buttonType="white" tooltip="Favoriten" tooltipDirection="bottom">
          <fa-icon [icon]="faStar" iconLeft></fa-icon>
          <span class="bic-btn-label--compact">Favoriten</span>
        </bic-button>
        @if (canManageMyChecks) {
          <bic-button (onClick)="createNewCheck()" buttonType="white" tooltip="Neuer Prüflauf" tooltipDirection="bottom">
            <fa-icon [icon]="faPlus" iconLeft></fa-icon>
            <span class="bic-btn-label--compact">Neuer Prüflauf</span>
          </bic-button>
        } @else {
          <span [tooltip]="noManageMyChecksTooltip" tooltipDirection="bottom">
            <bic-button [disabled]="true" buttonType="white">
              <fa-icon [icon]="faPlus" iconLeft></fa-icon>
              <span class="bic-btn-label--compact">Neuer Prüflauf</span>
            </bic-button>
          </span>
        }
      }
    </div>
  </app-page-header>

  <!-- Content -->
  <div class="flex flex-col gap-4 p-6 overflow-y-auto flex-1">
    @if (loading) {
      <!-- Skeleton-Loading State -->
      <div class="grid grid-flow-row gap-6 w-full"
           style="grid-template-columns: repeat(auto-fill, minmax(364px, 1fr));">
        @for (i of [1, 2, 3, 4]; track i) {
          <app-skeleton-card></app-skeleton-card>
        }
      </div>
    } @else {
      @if (isCatalog) {
        @if (filteredSharedChecks.length > 0) {
          <div class="grid grid-flow-row gap-6 w-full"
               style="grid-template-columns: repeat(auto-fill, minmax(364px, 1fr));">
            @for (check of filteredSharedChecks; track check.id) {
              <my-checks-card
                (action)="onCardAction($event)"
                [check]="check"
                [description]="check.description"
                [schedule]="schedulesByDefinitionId.get(check.id) ?? null">
              </my-checks-card>
            }
          </div>
        } @else {
          <app-empty-state [icon]="faCube" message="Keine BIC Prüfläufe verfügbar." class="flex-1"></app-empty-state>
        }
      } @else {
        @if (filteredChecks.length > 0) {
          <div class="grid grid-flow-row gap-6 w-full pb-6"
               style="grid-template-columns: repeat(auto-fill, minmax(364px, 1fr));">
            @for (check of filteredChecks; track check.id) {
              <my-checks-card
                (action)="onCardAction($event)"
                [actionLoading]="!!$any(check)._activating"
                [archived]="showArchived"
                [catalogSubmission]="catalogSubmissionFor(check)"
                [catalogSubmissionAllowed]="catalogSubmissionAllowed"
                [check]="check"
                [currentProjectId]="currentProjectId"
                [newCatalogVersion]="newCatalogVersionFor(check)"
                [description]="check.description"
                [pinned]="isCheckPinned(check)"
                [schedule]="schedulesByDefinitionId.get(check.id) ?? null">
              </my-checks-card>
            }
          </div>
        } @else {
          <app-empty-state [icon]="faCube" message="Keine eigenen Prüfläufe gefunden." class="flex-1">
            @if (canManageMyChecks) {
              <bic-button (onClick)="createNewCheck()" buttonType="white">
                <fa-icon [icon]="faPlus" iconLeft></fa-icon>
                Neuer Prüflauf
              </bic-button>
            } @else {
              <span [tooltip]="noManageMyChecksTooltip" tooltipDirection="top">
                <bic-button [disabled]="true" buttonType="white">
                  <fa-icon [icon]="faPlus" iconLeft></fa-icon>
                  Neuer Prüflauf
                </bic-button>
              </span>
            }
          </app-empty-state>
        }
      }
    }
  </div>
</div>

<!-- Popup: Neuen Prüflauf erstellen -->
@if (showCreatePopup) {
  <app-create-check-run-prompt
    (closed)="showCreatePopup = false"
    (confirmed)="onConfirmCreate($event)"
    [saving]="creating">
  </app-create-check-run-prompt>
}

<!-- Popup: Check Einstellungen -->
@if (showSettingsPopup) {
  <bic-popup (close)="onSettingsClose()" [customClass]="'w-[1000px]'" [title]="'Prüflauf anpassen'">
    <div bicPopupContent class="flex flex-col gap-4">
      <div class="flex flex-col gap-1">
        <bic-input (valueChange)="settingsName = $event"
                   [label]="'Check Name'"
                   [placeholder]="'Check Name'"
                   [value]="settingsName">
        </bic-input>
      </div>
      <div class="flex flex-col gap-1">
        <bic-textarea [(ngModel)]="settingsDescription"
                      [label]="'Check Beschreibung'"
                      placeholder="Beschreibung des Checks"
                      [rows]="3"></bic-textarea>
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-gray-900">Geplanter Auslöser</label>
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-900">Nein</span>
          <bic-toggle [(ngModel)]="settingsScheduledTrigger"></bic-toggle>
          <span class="text-sm text-gray-900">Ja</span>
        </div>
      </div>
    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
      <bic-button (onClick)="onSettingsClose()" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="onSettingsSave()" [loading]="saving" buttonType="primary">Übernehmen</bic-button>
    </div>
  </bic-popup>
}

<!-- Popup: Check anheften -->
@if (showPinPopup) {
  <bic-popup (close)="onPinClose()" [customClass]="'w-[520px]'" [title]="'Check anheften'">
    <div bicPopupContent class="flex flex-col gap-4">
      <p class="text-sm text-gray-900">
        Angeheftete Checks erscheinen als Verknüpfung in der Seitenleiste. Lege fest, für wen der
        Shortcut sichtbar ist. Ohne Auswahl wird der Check nur für dich angeheftet.
      </p>
      <div class="flex flex-col gap-3">
        <!-- Projektweit -->
        <label class="flex flex-row items-start gap-3 rounded-lg border border-gray-200 p-3 cursor-pointer hover:border-green">
          <input type="checkbox"
                 [(ngModel)]="pinProjectScoped"
                 [disabled]="pinLoading || pinSaving"
                 class="mt-0.5 h-4 w-4 rounded border-gray-300 text-green accent-green focus:ring-green"/>
          <span class="flex flex-col">
            <span class="text-sm font-medium text-gray-900">Projektweit anheften</span>
            <span class="text-xs text-gray-500">Alle Mitglieder dieses Projekts sehen den Shortcut.</span>
          </span>
        </label>
        <!-- Organisationsweit -->
        @if (canPinOrganisation) {
          <label class="flex flex-row items-start gap-3 rounded-lg border border-gray-200 p-3 cursor-pointer hover:border-green">
            <input type="checkbox"
                   [(ngModel)]="pinOrganisationScoped"
                   [disabled]="pinLoading || pinSaving"
                   class="mt-0.5 h-4 w-4 rounded border-gray-300 text-green accent-green focus:ring-green"/>
            <span class="flex flex-col">
              <span class="text-sm font-medium text-gray-900">Organisationsweit anheften</span>
              <span class="text-xs text-gray-500">Alle Mitglieder der Organisation sehen den Shortcut (erfordert entsprechende Berechtigung).</span>
            </span>
          </label>
        } @else {
          <div class="flex flex-row items-start gap-3 rounded-lg border border-gray-200 p-3 opacity-50 cursor-not-allowed"
               tooltip="Organisationsweites Anheften ist vorübergehend deaktiviert."
               tooltipDirection="top">
            <input type="checkbox"
                   [checked]="false"
                   [disabled]="true"
                   class="mt-0.5 h-4 w-4 rounded border-gray-300"/>
            <span class="flex flex-col">
              <span class="text-sm font-medium text-gray-900">Organisationsweit anheften</span>
              <span class="text-xs text-gray-500">Demnächst wieder verfügbar.</span>
            </span>
          </div>
        }
      </div>
    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full items-center gap-4">
      @if (pinAlreadyPinned) {
        <bic-button (onClick)="onPinRemove()" [loading]="pinSaving" buttonType="white">Lösen</bic-button>
      }
      <div class="flex-1"></div>
      <bic-button (onClick)="onPinClose()" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="onPinSave()" [loading]="pinSaving" buttonType="primary">Anheften</bic-button>
    </div>
  </bic-popup>
}

<!-- Popup: Seitenleiste anpassen (Favoriten) -->
@if (showFavoritesPopup) {
  <app-favorites-prompt (closed)="onFavoritesClosed()"></app-favorites-prompt>
}

<!-- Popup: Prüflauf archivieren (Bestätigung) -->
@if (checkToDelete) {
  <bic-popup (close)="cancelDeleteCheck()" [hasBackdrop]="true" customClass="w-[560px] h-fit"
             title="Prüflauf archivieren?">
    <div bicPopupContent class="flex flex-col">
      <span class="font-normal">Möchten Sie den Prüflauf „{{ checkToDelete.name }}" archivieren?<br><br>
        Er verschwindet aus dieser Übersicht, bereits erstellte Berichte bleiben erhalten. Sie können ihn jederzeit über den Filter „Archiviert" wiederherstellen.</span>
    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
      <bic-button (onClick)="cancelDeleteCheck()" [disabled]="deleting" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="confirmDeleteCheck()" [loading]="deleting" buttonType="primary">Archivieren</bic-button>
    </div>
  </bic-popup>
}

<!-- Popup: aus einem anderen Projekt geteilten Prüflauf duplizieren (fehlende myChecks mitkopieren?) -->
@if (linkedDuplicateCheck) {
  <app-duplicate-linked-check-prompt
    (closed)="closeLinkedDuplicate()"
    (confirmed)="onLinkedDuplicateConfirmed($event)"
    [checkName]="linkedDuplicateCheck.name"
    [rulesets]="linkedDuplicateRulesets"
    [saving]="linkedDuplicating">
  </app-duplicate-linked-check-prompt>
}

<!-- Popup: Katalog-Prüflauf duplizieren -->
@if (duplicateTarget) {
  <app-duplicate-check-prompt
    (closed)="closeDuplicateDialog()"
    (confirmed)="onDuplicateConfirmed($event)"
    [checkName]="duplicateTarget.name"
    [loadFailed]="duplicateLoadFailed"
    [loading]="duplicateLoading"
    [rulesets]="duplicateRulesets"
    [saving]="duplicating">
  </app-duplicate-check-prompt>
}

<!-- Popup: Prüflauf mit anderen Projekten der Organisation teilen -->
@if (projectShareCheck && currentProjectId) {
  <app-share-with-projects-prompt
    (closed)="projectShareCheck = null"
    (saved)="onProjectSharesSaved($event)"
    [checkName]="projectShareCheck.name"
    [definitionId]="projectShareCheck.id"
    [projectId]="currentProjectId">
  </app-share-with-projects-prompt>
}

<!-- Popup: geteilter Prüflauf – Eigentümer ändern bzw. archivieren (übergeben / überall entfernen) -->
@if (ownershipCheck && currentProjectId) {
  <app-project-ownership-prompt
    (closed)="ownershipCheck = null"
    (done)="onOwnershipDone()"
    [entity]="'check-run'"
    [itemId]="ownershipCheck.id"
    [itemName]="ownershipCheck.name"
    [mode]="ownershipMode"
    [projectId]="currentProjectId">
  </app-project-ownership-prompt>
}

<!-- Popup: geteilten Prüflauf aus diesem Projekt entfernen (Bestätigung) -->
@if (unshareHereCheck) {
  <bic-popup (close)="cancelUnshareHere()" [hasBackdrop]="true" customClass="w-[560px] h-fit"
             title="Aus diesem Projekt entfernen?">
    <div bicPopupContent class="flex flex-col">
      <span class="font-normal">Möchten Sie den geteilten Prüflauf „{{ unshareHereCheck.name }}" aus diesem Projekt entfernen?<br><br>
        Er bleibt in seinem Eigentümerprojekt bestehen. Bereits erstellte Berichte in diesem Projekt bleiben erhalten.</span>
    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
      <bic-button (onClick)="cancelUnshareHere()" [disabled]="unsharingHere" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="confirmUnshareHere()" [loading]="unsharingHere" buttonType="primary">Entfernen</bic-button>
    </div>
  </bic-popup>
}

<!-- Popup: Prüflauf in den Katalog einreichen (nur mit GLOBAL_CHECKRULE_ADMIN und erlaubter Stage) -->
@if (catalogSubmissionTarget) {
  <app-catalog-submission-prompt
    (closed)="closeCatalogSubmission()"
    (submitted)="onCatalogSubmitted($event)"
    [itemName]="catalogSubmissionTarget.name"
    [itemType]="'WORKFLOW'"
    [projectId]="currentProjectId"
    [sourceId]="catalogSubmissionTarget.id">
  </app-catalog-submission-prompt>
}

<!-- Popup: Zeitplan des Prüflaufs anlegen bzw. bearbeiten -->
@if (scheduleCheck && currentProjectId) {
  <app-check-run-schedule-popup
    (closed)="closeSchedulePopup()"
    (deleted)="onScheduleChanged()"
    (saved)="onScheduleChanged()"
    [definitionId]="scheduleCheck.id"
    [definitionName]="scheduleCheck.name"
    [projectId]="currentProjectId"
    [schedule]="scheduleCheckSchedule">
  </app-check-run-schedule-popup>
}
